import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
	appname: '',
	themeColor: '#8C33DE',
	virtualCurrencyUnit: 'gems',
	appid: ''
}

export default {
	state,
	getters,
	actions,
	mutations
};